import { MEDIA_TYPE, TRANSMISSION_TYPE } from 'src/interfaces/enums';
import * as yup from 'yup';

export const schemaDefault = yup
  .object()
  .shape({
    transmissionType: yup.mixed<TRANSMISSION_TYPE>().oneOf(Object.values(TRANSMISSION_TYPE)).required(),
    mediaType: yup.mixed<MEDIA_TYPE>().oneOf(Object.values(MEDIA_TYPE)).required(),
    isMediaPublic: yup.boolean().required(),
    applicationKey: yup.string().when('isMediaPublic', {
      is: (val) => {
        return val === false;
      },
      then: (schema) => schema.required('applicationKey is a required field when media is private'),
    }),
    duration: yup
      .number()
      .min(0)
      .when('transmissionType', {
        is: (value: TRANSMISSION_TYPE) => value === TRANSMISSION_TYPE.vod,
        then: (schema) => schema.required('duration is a required field when transmissionType is vod'),
      }),
    media: yup.string().required(),
    user: yup.string().when('isMediaPublic', {
      is: (val) => {
        return val === false;
      },
      then: (schema) => schema.required('user is a required field when media is private'),
    }),
    viewId: yup.string().required(),
    playerVersion: yup.string().required(),
  })
  .strict();
